import { render, staticRenderFns } from "./psp-errors.vue?vue&type=template&id=6f3864fa&scoped=true"
import script from "./psp-errors.vue?vue&type=script&lang=js"
export * from "./psp-errors.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f3864fa",
  null
  
)

export default component.exports